<template>
  <v-card-text>
    <v-card>
      <v-card-text>
        <v-form ref="membresiaForm">
          <v-row>
            <v-col md="6">
              <h4>Datos de la membresia</h4>
              <p class="font-weight-black">
                1.- Seleccione un plan de membresia.
              </p>
              <v-autocomplete
                label="Plan de membresia"
                v-model="Membresia.Plan"
                :rules="rules.plan"
                item-value="Id"
                item-text="Nomb"
                @change="selectPlan()"
                :items="Catalogos.PlanesMembresias"
              >
              </v-autocomplete>
              <v-select
                v-model="Membresia.Periodo"
                :rules="rules.periodoPago"
                label="Periodo de Pago"
                :items="comp_periodos"
                item-text="Nombre"
                item-value="Id"
              >
              </v-select>
              <v-text-field
                v-model="Membresia.DiaCargo"
                :rules="rules.diaCargo"
                type="number"
                label="Día de cargo"
                required
              ></v-text-field>
              <v-text-field
                v-model="Membresia.DiasProrroga"
                :rules="rules.DiasProrroga"
                type="number"
                label="Días de prorroga"
                required
              ></v-text-field>
              <v-row>
                <v-col md="12">
                  <v-text-field
                    @keypress="$pgsHelper.onlyNumber($event, Membresia.Code.Pos)"
                    @paste.prevent
                    v-model="Membresia.Code.Pos"
                    label="Número Membresia"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-alert v-if="!aux.selectedPlan" dense outlined type="error">
                Seleccione un plan de membresia para continuar
              </v-alert>
              <p class="font-weight-black mt-4">
                2.- Agrega clientes a la memebresia (Maximo
                {{ aux.selectedPlan ? aux.selectedPlan.NM : "0" }}).
              </p>
              <v-row>
                <v-col md="12">
                  <v-autocomplete
                    label="Titular de la membresia"
                    v-model="aux.titular"
                    :readonly="!aux.selectedPlan"
                    @change="selectTitular($event)"
                    item-value="Id"
                    item-text="text"
                    :items="comp_clients"
                  ></v-autocomplete>
                </v-col>
                <v-col md="8">
                  <v-autocomplete
                    label="Seleccione clientes para la membresia"
                    v-model="aux.cliente"
                    :readonly="!aux.selectedPlan"
                    item-value="Id"
                    item-text="text"
                    :items="comp_clients_no_membresia"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col md="4">
                  <v-btn
                    depressed
                    color="primary"
                    @click="addCliente()"
                    :readonly="!aux.selectedPlan"
                  >
                    Agregar
                  </v-btn>
                </v-col>
                <v-col md="12" cols="12">
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">Cliente</th>
                          <th class="text-left">Opciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(
                            clienteId, index
                          ) in Catalogos.ClientesMembresia"
                          :key="index"
                        >
                          <td>
                            {{ (getDataCliente(clienteId).text)? getDataCliente(clienteId).text: "El Cliente no existe o esta en proceso de descarga" }}
                            <v-icon
                              v-if="clienteId == Membresia.Titular"
                              color="yellow"
                              >mdi-star-circle</v-icon
                            >
                          </td>
                          <td>
                            <v-btn
                              v-if="clienteId != Membresia.Titular"
                              x-small
                              color="red"
                              dark
                              @click="deleteCliente(clienteId)"
                            >
                              Eliminar
                            </v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
            </v-col>
            <v-col md="6">
              <p class="font-weight-black mt-4">
                3.- Verificar Beneficios y Plan de pagos
              </p>
              <v-alert v-if="!aux.selectedPlan" dense type="info">
                Seleccione un plan de membresia para ver el detalle.
              </v-alert>
              <v-card elevation="0" class="mx-auto" v-if="aux.selectedPlan">
                <v-card-text class="text-h5">
                  {{ aux.selectedPlan.Nomb }}
                </v-card-text>
                <v-card-text v-if="aux.beneficiosPlan">
                  <v-tabs>
                    <v-tab> Plan de pagos </v-tab>
                    <v-tab> Beneficios </v-tab>
                    <v-tab-item>
                      <v-alert
                        outlined
                        color="deep-blue"
                        elevation="2"
                        class="mt-1"
                      >
                        <v-row align="center">
                          <v-col class="grow">
                            <div v-if="!aux.editAmounts">
                              <v-row>
                                <v-col cols="12" md="6" class="text-center">
                                  <v-list-item-subtitle
                                    >Costo de acción:
                                    <b
                                      >{{
                                        this.$pgsHelper.formatNumber(
                                          Membresia.PlanE.CPA.C
                                        )
                                      }}
                                      {{ Membresia.PlanE.CPA.M }}</b
                                    >
                                    <br/>
                                    <v-btn
                                      @click="openFinanceModal()"
                                      v-if="!financiado && !edit"
                                      class="mx-2"
                                      dark
                                      color="indigo"
                                      small
                                    >
                                      Financiar
                                    </v-btn>
                                    <v-btn
                                      v-if="comp_financiado"
                                      class="mx-2"
                                      dark
                                      color="green"
                                      small
                                    >
                                      Financiado
                                    </v-btn>
                                  </v-list-item-subtitle>
                                </v-col>
                                <v-col cols="12" md="6" class="text-center">
                                  <v-list-item-subtitle
                                    >Costo Anual:
                                    <b
                                      >{{
                                        this.$pgsHelper.formatNumber(
                                          Membresia.PlanE.CA.C
                                        )
                                      }}
                                      {{ Membresia.PlanE.CA.M }}</b
                                    >
                                    <br/>
                                    <v-btn
                                      v-if="!comp_domiciliado"
                                      @click="openDomModal()"
                                      class="mx-2"
                                      dark
                                      color="indigo"
                                      small
                                    >
                                      Domiciliar Linea de Crédito
                                    </v-btn>
                                    <v-btn
                                      v-if="comp_domiciliado"
                                      @click="openDomModal()"
                                      class="mx-2"
                                      dark
                                      color="green"
                                      small
                                    >
                                      Linea de credito {{Membresia.ExtraParams.Domiciliado.Tip}}
                                    </v-btn>
                                  </v-list-item-subtitle>
                                </v-col>
                              </v-row>
                              <v-col cols="12" md="12" class="text-center">
                                <v-list-item-subtitle
                                class="mt-4"
                                >Deuda:
                                <b
                                  v-bind:class="[
                                    Membresia.Deuda.C > 0
                                      ? 'red--text'
                                      : 'green--text',
                                  ]"
                                  >{{
                                    this.$pgsHelper.formatNumber(
                                      0 > Membresia.Deuda.C
                                        ? Membresia.Deuda.C * -1
                                        : Membresia.Deuda.C
                                    )
                                  }}
                                  {{ Membresia.Deuda.M }}
                                  {{
                                    0 > Membresia.Deuda.C ? "Saldo a favor" : ""
                                  }}</b
                                ></v-list-item-subtitle
                              >
                              </v-col>
                              <v-list-item-subtitle v-if="false"
                                >Tasa de Interes Anual:
                                <b
                                  >{{
                                    this.$pgsHelper.formatNumber(
                                      Membresia.PlanE.TIA
                                    )
                                  }}
                                  %</b
                                ></v-list-item-subtitle>
                            </div>
                            <div v-if="aux.editAmounts">
                              <v-row>
                                <v-col cols="12" md="6">
                                  <v-text-field
                                    v-model.number="Membresia.PlanE.CPA.C"
                                    type="number"
                                    label="Costo de acción"
                                    outlined
                                    dense
                                    required
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <v-select
                                    v-model="Membresia.PlanE.CPA.M"
                                    :items="aux.monedas"
                                    item-value="id"
                                    item-text="Nombre"
                                    label="Moneda Comisión por apertura Apertura"
                                    outlined
                                    dense
                                    required
                                  ></v-select>
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="6"
                                  style="margin-top: -30px"
                                >
                                  <v-text-field
                                    v-model.number="Membresia.PlanE.CA.C"
                                    type="number"
                                    label="Costo Anual"
                                    outlined
                                    dense
                                    required
                                  ></v-text-field>
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="6"
                                  style="margin-top: -30px"
                                >
                                  <v-select
                                    v-model="Membresia.PlanE.CA.M"
                                    :items="aux.monedas"
                                    item-value="id"
                                    item-text="Nombre"
                                    label="Moneda Costo Anual"
                                    outlined
                                    dense
                                    required
                                  ></v-select>
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="12"
                                  style="margin-top: -30px"
                                >
                                  <v-text-field
                                    v-model.number="Membresia.PlanE.TIA"
                                    type="number"
                                    label="Tasa de Interes Anual"
                                    outlined
                                    dense
                                    required
                                  ></v-text-field>
                                </v-col>
                                <v-col
                                  v-if="!edit"
                                  cols="12"
                                  md="6"
                                  style="margin-top: -30px"
                                >
                                  <v-text-field
                                    v-model.number="Membresia.Deuda.C"
                                    type="number"
                                    label="Deuda Actual"
                                    outlined
                                    dense
                                    required
                                  ></v-text-field>
                                </v-col>
                                <v-col
                                  v-if="!edit"
                                  cols="12"
                                  md="6"
                                  style="margin-top: -30px"
                                >
                                  <v-select
                                    v-model="Membresia.Deuda.M"
                                    :items="aux.monedas"
                                    item-value="id"
                                    item-text="Nombre"
                                    disabled
                                    label="Moneda Deuda Actual"
                                    outlined
                                    dense
                                    required
                                  ></v-select>
                                </v-col>
                                <v-col class="shrink">
                                  <v-btn
                                    @click="aux.editAmounts = false"
                                    color="blue"
                                    outlined
                                    >Confirmar</v-btn
                                  >
                                </v-col>
                              </v-row>
                            </div>
                            <v-btn
                            block
                              v-if="aux.editAmounts != true"
                              @click="aux.editAmounts = true"
                              outlined
                              small
                              >Ajustar Cantidades</v-btn>
                          </v-col>
                        </v-row>
                      </v-alert>
                      Plan de pago Costo Anual
                      <TablaPlanPagos :Membresia="Membresia"></TablaPlanPagos>
                    </v-tab-item>
                    <v-tab-item>
                      <template
                        v-for="(
                          beneficio, index
                        ) in aux.beneficiosPlan.getBeneficiosList()"
                      >
                        <v-list-item :key="index" v-show="beneficio.Activo">
                          <v-list-item-icon>
                            <v-icon color="yellow">mdi-star</v-icon>
                          </v-list-item-icon>
                          <v-list-item-subtitle
                            >{{
                              beneficio.Cantidad
                                ? beneficio.Cantidad
                                : "Iimitado"
                            }}
                            - {{ beneficio.Desc }}
                            {{
                              beneficio.Precio
                                ? "a precio: " +
                                  beneficio.Precio.C +
                                  " " +
                                  beneficio.Precio.M
                                : ""
                            }}
                          </v-list-item-subtitle>
                        </v-list-item>
                      </template>
                    </v-tab-item>
                  </v-tabs>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <div class="text-right">
            <v-btn large @click="$emit('toggle', false)">Cancelar</v-btn>
            <v-btn
              style="margin-left: 6px"
              color="success"
              large
              @click="checkForm"
              >Guardar</v-btn
            >
          </div>
          <modal v-model="dialogsFinanciar" :showFooter="false">
            <CreditoForm
            :modeActionFinancial="true"
            :preloadData="preloadData"
            :key="FinanciarIndex"
            @successData="successData"
            />
          </modal>
          <modal v-model="dialogSelectCredito" :showFooter="false">
            Vincular una linea de crédito
            <v-select
                :items="clienteLineasCredito"
                v-model="lineaSelected"
                label="Linea de crédito"
                class="mt-4"
                item-text="text"
                item-value="id"
                outlined
                dense
                required
              ></v-select>
              <div class="text-right">
                <v-btn
                  color="primary"
                  dark
                  @click="vincularLinea()"
                >
                  Vincular
                </v-btn>
              </div>
          </modal>
        </v-form>
      </v-card-text>
    </v-card>
  </v-card-text>
</template>

<style scoped></style>

<script>
import MembresiaClass from "../../../clases/Membresias/Membresia.js";
import MembresiaPlan from "../../../clases/Membresias/MembresiaPlan.js";
import PeriodosCobro from "../../../clases/Membresias/PeriodosCobro.js";
import Currency from "../../../clases/Currencies.js";
import Cliente from "../../../clases/Cliente.js";
import TablaPlanPagos from "../../MainComponents/Membresias/TablaPlanPagos.vue";
import CreditoForm from "../../LineasCredito/CreditoForm.vue";
import { mapGetters } from "vuex";
export default {
  name: "MembresiaForm",
  components: { TablaPlanPagos,CreditoForm },
  props: ["edit", "dataEdit"],
  data() {
    return {
      Membresia: MembresiaClass.getPropertyModel(),
      dialogsFinanciar:false,
      dialogSelectCredito:false,
      lineaSelected:"",
      clienteLineasCredito : [],
      financiado:false,
      domiciliado:false,
      preloadData:{
        cliente:"",
        tipo:"",
        cantidad:""
      },
      FinanciarIndex:1,
      aux: {
        titular: "",
        cliente: "",
        selectedPlan: null,
        beneficiosPlan: null,
        editAmounts: false,
        monedas: [],
        useAutoincrement: true,
      },
      rules: {
        DiasProrroga:[(value) => (value >= 0) || "Los dias de prorroga son obligatorios"],
        plan: [(value) => !!value || "El plan de membresia es obligatorio"],
        periodoPago: [
          (value) => !!value || "El periodo de pago es obligatorio",
        ],
        diaCargo: [
          (value) =>
            (value >= 1 && value <= 20) ||
            "El dia de cobro debe estar entre 1 y 20",
        ],
      },
      Catalogos: {
        PlanesMembresias: [],
        ClientesMembresia: [],
      },
    };
  },
  methods: {
    vincularLinea(){
      this.Membresia.ExtraParams.Domiciliado = {
        Tip:"PGS-Credito",
        Cod: this.lineaSelected
      };
      
      this.domiciliado = true;
      this.dialogSelectCredito = false
      this.$forceUpdate();
    },
    successData(data, doAction) {
      data.DiaCargo = Number(data.DiaCargo);
      data.DiasProrroga = Number(data.DiasProrroga);
      
      if (doAction == "CREATE") {
        this.createMembresia(data);
      }else if (doAction == "FINACCION") {
        this.addFinancialMembresia(data);
      }else if (doAction == "EDIT") {
        this.editarMembresia(data);
      }
    },
    addFinancialMembresia(data){
      this.Membresia.ExtraParams.financiacionApertura = data;
      this.financiado = true;
      this.dialogsFinanciar = false
    },
    openFinanceModal(){
      
      this.preloadData = {
        cliente:this.Membresia.Titular,
        tipo:"FIN",//REV
        cantidad:this.Membresia.PlanE.CPA.C
      }
      
      this.dialogsFinanciar = true;
    },
    openDomModal(){
      let data = this.getBNK_LineasCredito.filter((lc) => {
        lc.text = "Linea de credito Num. "+lc.ncdt +" || "+"Limite de credito:"+lc.lcdt
        return (lc.clnt == this.Membresia.Titular && lc.tip == 'REV');
      })
      this.clienteLineasCredito = data
      this.dialogSelectCredito = true
    },
    selectTitular($event) {
      this.Membresia.Clientes[this.aux.titular] = {};
      delete this.Membresia.Clientes[this.Membresia.Titular];
      this.Membresia.Titular = this.aux.titular;
      this.Catalogos.ClientesMembresia = this.Membresia.getClientesAsArray();
    },
    addCliente() {
      
      if(this.aux.cliente === ''){
        return false
      }
      if (this.aux.selectedPlan?.NM) {
        if (
          this.Membresia.getClientesAsArray().length < this.aux.selectedPlan.NM
        ) {
          if (!this.Membresia.getClientesAsArray().includes(this.aux.cliente)) {
            this.Membresia.Clientes[this.aux.cliente] = {};
          } else {
            this.$swal(
              "El cliente ya se encuentra dentro del plan",
              "",
              "error"
            );
          }
        } else {
          this.$swal(
            "Superaste el maximo de clientes permitidos en el plan de pago de membresia",
            "",
            "error"
          );
        }
      } else {
        this.$swal("Seleccione un plan de membresia", "", "error");
      }
      this.Catalogos.ClientesMembresia = this.Membresia.getClientesAsArray();
      this.$forceUpdate();
    },
    deleteCliente(id) {
      delete this.Membresia.Clientes[id];
      this.Catalogos.ClientesMembresia = this.Membresia.getClientesAsArray();
      this.$forceUpdate();
    },
    async selectPlan(initLoad = false) {
      this.aux.selectedPlan = this.$pgsHelper.getById(
        this.Catalogos.PlanesMembresias,
        "Id",
        this.Membresia.Plan
      );
      if(this.aux.selectedPlan){
        this.aux.beneficiosPlan = await this.aux.selectedPlan.getBeneficios();
      }
      //this.aux.beneficiosPlan = await this.aux.selectedPlan.getBeneficios();
      if (!initLoad) {
        this.Membresia.PlanE.CA = this.aux.selectedPlan.CA;
        this.Membresia.PlanE.CPA = this.aux.selectedPlan.CPA;
        this.Membresia.PlanE.TIA = this.aux.selectedPlan.TIA;
        //this.Membresia.Code.Pre  = this.aux.selectedPlan.Cve
      }
      this.$forceUpdate();
    },
    getDataCliente(id) {
      let data = {};
      data = this.$pgsHelper.getById(this.comp_clients, "Id", id);
      return data;
    },
    checkForm() {
      if (this.$refs.membresiaForm.validate()) {
        let doAction = "CREATE";
        if (this.edit) {
          doAction = "EDIT";
        }
        this.send(doAction);
      }
    },
    send(action) {
      const dataSave = JSON.parse(JSON.stringify(this.Membresia));
      if (this.Membresia.getClientesAsArray().length == 0) {
        this.$swal(
          "Agrega al menos un cliente a la membresia",
          "Todas las memebresias deben tener al menos un cliente seleccionado",
          "error"
        );
        return false;
      }
      //if(action == 'CREATE'){
      dataSave.DiaCargo = Number(dataSave.DiaCargo);
      dataSave.DiasProrroga = Number(dataSave.DiasProrroga);
      dataSave.Clientes = Object.keys(dataSave.Clientes);
      //}
      this.$emit("successData", dataSave, action);
    },
  },
  computed: {
    ...mapGetters("dataLists",["getBNK_LineasCredito"]),
    comp_clients_no_membresia() {
      let clientes = [];
      let rowclientes = Cliente.getClientsList();
      rowclientes.forEach((element) => {
        if (element.Id != "PUBLICOGENERAL") {
          if (element.Id != this.Membresia.Titular) {
            if (element?.ExtraData?.Membresia?.Membresia) {
              if (this.edit) {
                if (
                  element.ExtraData.Membresia.Membresia == this.Membresia.Id
                ) {
                  clientes.push(element);
                }
              }
            } else {
              clientes.push(element);
            }
          }
        }
      });
      clientes.forEach((cli) => {
        cli.value = cli.id;
        cli.text = cli.getNombreCompleto();
      });
      return clientes;
    },
    comp_clients() {
      let clientes = [];
      let rowclientes = Cliente.getClientsList();
      rowclientes.forEach((element) => {
        if (element.Id != "PUBLICOGENERAL") {
          clientes.push(element);
        }
      });
      clientes.forEach((cli) => {
        cli.value = cli.Id;
        cli.text = cli.getNombreCompleto();
      });
      return clientes;
    },
    comp_planPagos() {
      let pagos = [];
      let nPagos = 12;
      let interes = this.Membresia.PlanE.TIA / 100 / nPagos;
      let montoInicial = this.aux.selectedPlan
        ? Currency.getExchangeRateByCurrency(
            this.Membresia.PlanE.CA.C,
            this.Membresia.PlanE.CA.M,
            Currency.getCurrencyDefault()
          )
        : 0;
      let saldo = montoInicial;

      for (let index = 1; index <= nPagos; index++) {
        //calculo del pago por periodo
        let montoPagoPeriodo =
          interes > 0
            ? (montoInicial * interes) / (1 - Math.pow(1 + interes, 0 - nPagos))
            : montoInicial / nPagos;
        //calculo de intereses del periodo
        let interesPeriodo = saldo * interes;
        //  calculo de amortizacion por periodo
        let amortizacion = montoPagoPeriodo - interesPeriodo;
        // calculo del saldo
        saldo = saldo - amortizacion;
        pagos.push({
          pago: index,
          cantidad: parseFloat(montoPagoPeriodo).toFixed(2),
          interes: parseFloat(interesPeriodo).toFixed(2),
          amortizacion: parseFloat(amortizacion).toFixed(2),
          saldo: parseFloat(saldo).toFixed(2),
          plan: this.Membresia.Plan,
        });
        let test = 0 + 45;
        test; //?
      }

      return pagos;
    },
    comp_periodos() {
      return PeriodosCobro.getPeriodosCobroList();
    },
    comp_clientesMembresia() {
      let data = this.Membresia;
      let clientes = data.Clientes ? data.Clientes : {};
      return Object.keys(clientes);
    },
    comp_domiciliado(){
      
      let data = (this.Membresia.ExtraParams.Domiciliado)?this.Membresia.ExtraParams.Domiciliado:false
      return data;
    },
    comp_financiado(){
      
      let data = (this.Membresia.ExtraParams.financiacionApertura)?this.Membresia.ExtraParams.financiacionApertura:false
      return data;
    }

  },
  beforeMount: async function () {
    this.Catalogos.PlanesMembresias = MembresiaPlan.getMembresiasPlanList();
    if (this.edit) {
      this.Membresia = this.dataEdit;
      this.aux.titular = this.Membresia.Titular;
      this.selectPlan(true);
    } else {
      this.Membresia = new MembresiaClass();
    }
    this.Catalogos.ClientesMembresia = this.Membresia.getClientesAsArray();
  },
  mounted() {
    this.aux.monedas = Currency.getCurrencies();
    //localStorage.getItem("selectedDepartment");
    //0.02  106250
  },
  watch: {},
};
</script>
